import React from "react";
import { Timeline, Box } from "fw/components";
import { ContentHeader, ContentBody } from 'areas/shared/components';
import * as API from 'modules/app/API';
import * as RecentHelper from 'modules/app/Recent';

class Recent extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });

        API.App.get('/query/getWeeklyRecents', null, {
            success: (r) => {
                let recentList = r.data.recents.map((recent, rKey) => {
                    let items = recent.items.map((recent, iKey) => {
                        let type = RecentHelper.getTypes().find(t => {
                            return t.recentTypeCode === recent.recentType
                        });

                        if (type)
                            return {
                                href: type.urlPattern.replace(":id", recent.entityKey),
                                icon: type.iconName,
                                text: recent.text,
                                time: recent.time
                            };

                        return null;
                    });

                    return {
                        date: recent.date,
                        items: items
                    };
                });

                this.setState({
                    list: recentList,
                    loading: false
                });
            }
        });
    }

    render() {
        let content;

        if (this.state.loading)
            content = <p>Loading...</p>;
        else
            content = <Timeline list={this.state.list} />;

        return (
            <React.Fragment>
                <ContentHeader title="Recent activities" description="Activity history in the application.">
                </ContentHeader>
                <ContentBody>
                    <Box>
                        {content}
                    </Box>
                </ContentBody>
            </React.Fragment>
        );
    }
}

export default Recent;



// WEBPACK FOOTER //
// ./src/areas/main/recent/Recent.js